module.exports = __webpack_public_path__ + "img/waves02.d8e33bab.png";